import financialApi from 'api/requests/financial'
import Chips from 'components/_UI/Chips';
import Loader from 'components/_UI/Loader';
import Paginate from 'components/_UI/Paginate';
import Table from 'components/_UI/Table';
import Text from 'components/_UI/Text'
import NotResultDashBoard from 'components/commons/NotResultDashBoard'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import colors from 'theme/colors';
import fonts from 'theme/fonts';
import FinancialStatusIcon from '../status/FinancialStatusIcon';
import { Row } from 'styled/alignment/Row';
import currency from 'helpers/currency';

export default function TransactionsList() {
    const [content, setContent] = useState(null);
    const [paginate, setPaginate] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getTransactions();
    }, [])

    const transactionTypes = {
        withdraw: 'withdraw',
        refund: 'refund',
        sell: 'sell'
    }

    async function getTransactions(number = 1) {
        setLoading(true);
        try {
            const { data } = await financialApi.getStatementBalance({ page: number })
            setContent(data?.data)
            setPaginate(data)
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    const transactionsData = content?.map(item => {
        const date = new Date(item.created_at);
        return {
            description:
                <Row>
                    <FinancialStatusIcon status={item?.category} />
                    <Column>
                        <Text paddingBottom={0} color={colors.nightDark}>
                            {item.description}
                        </Text>
                        <Text name='small'>
                            {date.toLocaleDateString('pt-BR')} - {date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                        </Text>
                    </Column >
                </Row>
            ,
            // date: `${date.toLocaleDateString('pt-BR')} - ${date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`,
            type:
                <TypeText category={item.category}>
                    {item.category === transactionTypes.sell && 'Receita'}
                    {item.category === transactionTypes.withdraw && 'Saque'}
                    {item.category === transactionTypes.refund && 'Estorno'}
                </TypeText>,
            gross_value: <>
                {
                    item?.category === transactionTypes.refund || item?.category === transactionTypes.withdraw
                        ? <Text color={colors.danger}>-{currency.format(item.gross_value)}</Text>
                        : <Text color={colors.success}>{currency.format(item.gross_value)}</Text>
                }
            </>,
            // `R$ ${parseFloat(item.gross_value).toFixed(2).replace('.', ',')}`,
            tax_value: <Text>{currency.format(item.tax_value)}</Text>,
            liquid_value: `R$ ${parseFloat(item.liquid_value).toFixed(2).replace('.', ',')}`,
            status: <StatusText status='success'>
                Processado
            </StatusText>,
        };
    });

    return (
        <Container>
            {
                loading ? <Loader /> : (
                    content?.length > 0 ? (
                        <>
                            <Text name='highlight'>Transações recentes</Text>
                            <Table
                                rows={transactionsData}
                                columns={['Descrição', 'Tipo', 'Valor bruto', 'Taxa', 'Valor líquido', 'Status']}
                            />
                            {
                                paginate?.last_page > 1 && (
                                    <Paginate
                                        onPaginate={number => getTransactions(number)}
                                        perPage={paginate?.perPage}
                                        totalItems={paginate?.totalItems}
                                        lastPage={paginate?.lastPage}
                                        firstPage={1}
                                        currentPage={paginate?.currentPage}
                                        marginTop={'30px'}
                                    />

                                )
                            }
                        </>
                    ) : (
                        <NotResultDashBoard
                            text={
                                <>
                                    <Text name='subtitle'>Transações recentes</Text>
                                    <Text>Parece que você ainda não possui transações recentes.</Text>
                                    <Text>Que tal criar um evento e começar a faturar?</Text>
                                </>
                            }
                            ilustration={'transactions'}
                            marginTop={'15px'}
                        />
                    )
                )}
        </Container>
    )
}

const Container = styled(Column)`
    background-color: ${colors.neutralLight};
    border-radius: 8px;
    padding: 20px;
    margin-top: 10px;
    box-shadow: 0 2px 7px #ddd;
`;

const StatusText = styled.p`
    padding: 4px 2px;
    margin-top: 4px;
    font-size: ${fonts.sizes.small} !important;
    width: 80px;
    border-radius: 50px;
    text-align: center;
    color: ${colors.night};
    font-weight: bold;

    ${({ status }) => status === 'pending' && `
        background: #FEF9C3;
        color: ${colors.occasionalOrange};
        border: 1px solid ${colors.occasionalOrange};
    `};
    
    ${({ status }) => status === 'success' && `
        background: #DCFCE7;
        color: ${colors.successDark};
        border: 1px solid ${colors.successDark};
    `};
`

const TypeText = styled.p`
    padding: 4px 2px;
    font-size: ${fonts.sizes.small} !important;
    width: 80px;
    border-radius: 50px;
    text-align: center;
    font-weight: bold;

    ${({ category }) => category === 'sell' && `
        color: ${colors.successDark};
        border: 1px solid ${colors.successDark};
    `};
    
    ${({ category }) => category === 'withdraw' && `
        color: ${colors.primary};
        border: 1px solid ${colors.primary};
    `};
    
    ${({ category }) => category === 'refund' && `
        color: ${colors.danger};
        border: 1px solid ${colors.danger};
    `};
`

